module.exports = __webpack_public_path__ + "static/img/ECOCASANCO.ed37299e.jpg";